module.exports = __webpack_public_path__ + "static/img/interview-with-raph-mokades.cfe0ede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/interview-with-raph-mokades.png
// module id = koKv
// module chunks = 0